module.exports = __webpack_public_path__ + "static/media/email.33f44427.svg";